import { render, staticRenderFns } from "./RoundCancel.vue?vue&type=template&id=bd2dd4aa&scoped=true&"
import script from "./RoundCancel.vue?vue&type=script&lang=ts&"
export * from "./RoundCancel.vue?vue&type=script&lang=ts&"
import style0 from "./RoundCancel.vue?vue&type=style&index=0&id=bd2dd4aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2dd4aa",
  null
  
)

export default component.exports